/**
 *
 * Asynchronously loads the component for TutorialsPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
